export const DONUT_COLORS = ["#f97316", "#eab308", "#92400e", "#fb923c", "#facc15", "#d97706"];
